<template>
    <v-flex xs12>
        <v-list dense three-line>
            <v-list-tile
            class="heightAuto"
            v-for="(comment, i) in comentarios"
            :key="comment.id"
            >
                <v-list-tile-content>
                    <v-list-tile-title class="heightAuto">
                        <v-layout row wrap>
                            <v-flex xs9>
                                <v-text-field counter="80" maxlength="80" v-model="comment.comment" label="Comentario" type="text" :rules="lenRule"></v-text-field>
                            </v-flex>
                            <v-flex xs3>
                                <v-btn
                                fab
                                small
                                color="primary"
                                
                                @click="deleteComment(i)"
                                >
                                    <v-icon style="color: white !important">
                                        delete
                                    </v-icon>
                                </v-btn>
                                <v-btn
                                v-if="comentarios.length == i+1"
                                fab
                                small
                                color="primary"
                                @click="newComment"
                                >
                                    <v-icon style="color: white !important">
                                        add
                                    </v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-flex>
</template>

<script>
export default {
    name: 'commentList',
    data(){
        return{
            //comentarios: [{ comment: '', id: 1}],
            //comentario: '',
            lenRule: [ 
                v => ( v.length < 80) || "Longitud máxima 80 caracteres",
            ],
        }
    },
    methods: {
        newComment(){
            var com = { comment: '', id: this.comentarios[this.comentarios.length-1].id+1}
            this.comentarios.push(com);
        },
        deleteComment(index){
            if (this.comentarios.length == 1){
                this.comentarios[0].comment = '';
            } else {
                this.comentarios.splice(index,1);
            }
        }
    },
    computed: {
        comentarios: {
            get(){
                console.log('a');
                return this.$store.state.dialogCreateTodoData.comentarios;
            },
            set(value){
                this.$store.commit('setComentariosVisita',value)
            }
        }
    }
}
</script>

<style>
.heightAuto{
    height: auto !important;
}
</style>